import React, { useEffect, useState } from "react";
import { FaCheck, FaInfoCircle, FaTimes } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import { useWalletInfo } from "@reown/appkit/react";
import { httpReauest } from "../../utils/httpRequest";

const PreSaleTask = ({ user }) => {
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);
  const [presaleReward, setpresaleReward] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const res = await httpReauest("GET", "/tasks", {}, {});
    setpresaleReward(res.data.data?.presaleReward);
  }

  const { walletInfo } = useWalletInfo();

  return (
    <div className="flex justify-between gap-3 items-center relative py-2 pb-4 border-b">
      <span className="flex items-center gap-2 lg:gap-4">
        <img
          src="https://www.filetrust.io/img/Logo_white.svg"
          className="w-8 lg:w-16"
          alt="Logo"
        />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2 flex items-center gap-2">
            Buy Filetrust Token
            <FaInfoCircle
              className="text-blue-400 cursor-pointer"
              onClick={() => setIsRewardModalOpen(true)}
              title="Help"
            />
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            Starts from
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />
            2000
          </span>
        </span>
      </span>

      <span className="flex flex-wrap gap-2 justify-end">
        <button
          onClick={() => {
            if (walletInfo?.name === "MetaMask") {
              setIsBuyModalOpen(true);
            } else {
              window.open(`https://buy.filetrust.io?user=${user?._id}`);
            }
          }}
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          Start
        </button>
      </span>

      {/* Reward Modal */}
      {isRewardModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] text-white rounded-2xl shadow-xl max-w-[90%] w-full sm:w-[600px] p-6">
            <div className="flex justify-between items-center mb-4 text-white">
              <h2 className="text-2xl font-bold ">Investment Rewards</h2>
              <button
                onClick={() => setIsRewardModalOpen(false)}
                className="text-gray-600 hover:text-red-500 text-lg"
              >
                <FaTimes />
              </button>
            </div>

            <div className="space-y-4">
              {[
                {
                  label: "Up to  $20 (USDT or Equivalent to ETH)",
                  total: presaleReward[0],
                },
                {
                  label: "Up to  $50 (USDT or Equivalent to ETH)",
                  total: presaleReward[1],
                },
                {
                  label: "Between $50 to $200 USDT or ETH",
                  total: presaleReward[2],
                },
                {
                  label: "Between $200 to $500 USDT or ETH",
                  total: presaleReward[3],
                },
                {
                  label: "Between $500 to $1000 USDT or ETH",
                  total: presaleReward[4],
                },
                { label: "Above $1000 USDT or ETH", total: presaleReward[5] },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex justify-between items-center bg-gray-600 rounded-lg px-4 py-3 text-sm sm:text-base"
                >
                  <span className="text-gray-200 font-medium">
                    {item.label}
                  </span>
                  <span className="text-[#fff] font-bold">
                    +{item.total.toLocaleString()}
                  </span>
                </div>
              ))}
            </div>

            <p className="mt-6 text-center text-gray-300 text-sm">
              💡 Note: Rewards will be added based on your investment range.
            </p>
          </div>
        </div>
      )}

      {/* Buy Token Modal */}
      {isBuyModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] text-white rounded-2xl shadow-xl max-w-[90%] w-full sm:w-[800px] h-[80%] p-4 relative">
            <button
              onClick={() => setIsBuyModalOpen(false)}
              className="absolute top-4 right-4 text-gray-300 hover:text-red-500 text-2xl"
            >
              <FaTimes />
            </button>
            <iframe
              key={user?._id}
              src={`https://buy.filetrust.io?user=${user?._id}`}
              title="Buy Filetrust Token"
              className="w-full h-full rounded-lg"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreSaleTask;
